/* Dining report options */
import {helpers} from '@/ft-vue-core'

const {displayTime, displayDateTime} = helpers

export default {
  computed: {
    groupingOptions () {
      return [
        {
          id: 1,
          name: 'Location',
          group: [
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total',
              caption: (row, rowIndex, rows) => {return row.locationName},
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 2,
          name: 'Reservation Time',
          group: [
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total',
              caption: (row, rowIndex, rows) => {
                return displayDateTime(row.dateTime)
              },
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 3,
          name: 'Location & Time',
          group: [
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total'
            },
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total',
              caption: (row, rowIndex, rows) => {
                return row.locationName + ' - ' + displayDateTime(row.dateTime) + ' (' + row.mealPeriodName + ')'
              },
              emptyRows: this.reportFilters.emptyRows
            }
          ],
          fields: ['mealPeriodName']
        },
        {
          id: 4,
          name: 'Time & Location',
          group: [
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total'
            },
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total',
              caption: (row, rowIndex, rows) => {
                return displayDateTime(row.dateTime) + ' (' + row.mealPeriodName + ')' + ' - ' + row.locationName
              },
              emptyRows: this.reportFilters.emptyRows
            }
          ],
          fields: ['mealPeriodName']
        }
      ]
    },
    columnOptions () {
      return this.baseColumnOptions.filter(c => ![30, 31, 32].includes(c.id)) // Exclude event Name column
    }
  }
}
